var BALLREFERENCES = (function () {
  function init() {
    const allReferencesWrapper = document.querySelectorAll(".b-all-references");

    allReferencesWrapper.forEach((wrapper) => {
      let initialOffset = 3;
      let offset = 3;
      const moreButton = wrapper.querySelector(".b-all-reference__more-button");
      const references = wrapper.querySelectorAll(
        ".b-all-references__reference"
      );

      moreButton.addEventListener("click", (e) => {
        e.preventDefault();

        references.forEach((reference, i) => {
          if (i + 1 > initialOffset && i + 1 <= initialOffset + offset) {
            reference.classList.add("is-active");
          }
        });

        initialOffset += offset;

        if (initialOffset >= references.length) {
          moreButton.disabled = true;
        }
      });
    });
  }

  return {
    init: init,
  };
})();
